var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-3 main-card"},[_c('div',{staticClass:"page"},[_c('div',{staticClass:"d-flex align-center mb-4 page-header"},[_vm._t("header")],2),(!_vm.hideDivider)?_c('v-divider'):_vm._e(),_c('div',[_vm._t("content")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }